import { GET_LIST, CREATE, GET_ONE } from 'react-admin';

import * as constants from '../../constants/index';
import {
    CITIES_INFO,
    CONFIRM_OFFER_FLIGHT_REQUEST,
    FLIGHT_TYPES_INFO,
    FIRST_CONFIRM_MONITORING,
    FLIGHT_REQUEST_CREATED,
    CONFIRM_OFFER_FLIGHT_REQUEST_CLEAR,
    GET_FLIGHT_REQUEST,
    GET_FLIGHT_REQUEST_CLEAR,
    AIRLINE_FINAL_REJECT_FLIGHT_REQUEST,
    AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_CLEAR,
    AIRLINE_REQUEST_AFTER_REJECTION,
    AIRLINE_REQUEST_AFTER_REJECTION_CLEAR,
} from './types';

export const getCityList = () => ({
    type: CITIES_INFO,
    meta: { fetch: GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.CITY.GET_CITY_LIST}` },
});

export const getFlightTypesList = () => ({
    type: FLIGHT_TYPES_INFO,
    meta: {
        fetch: GET_LIST,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_TYPES.GET_FLIGHT_TYPES}`,
    },
});

export const clearFlightRequest = () => ({
    type: GET_FLIGHT_REQUEST_CLEAR,
    payload: {},
});

export const getFlightRequest = (flightRequestId: string) => ({
    type: GET_FLIGHT_REQUEST,
    payload: { id: flightRequestId },
    meta: {
        fetch: GET_ONE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.GET_FLIGHT_REQUEST}`,
    },
});

export const confirmOfferFlightRequest = (flightRequest: any, flightRequestIsChanged: Boolean) => ({
    type: CONFIRM_OFFER_FLIGHT_REQUEST,
    payload: { data: { flightRequest, flightRequestIsChanged } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.CONFIRM_OFFER_REQUEST}`,
    },
});

export const finalRejectionOfFlightRequest = (flightRequest: any) => ({
    type: AIRLINE_FINAL_REJECT_FLIGHT_REQUEST,
    payload: { data: { flightRequest } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.AIRLINE_REJECT_FLIGHT_REQUEST}`,
    },
});

export const airlineReRequest = (flightRequest: any) => ({
    type: AIRLINE_REQUEST_AFTER_REJECTION,
    payload: { data: { flightRequest } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.AIRLINE_REQUEST_AFTER_REJECTION}`,
    },
});

export const showErrorNotification = (errorMessage: any) => ({
    type: FIRST_CONFIRM_MONITORING,
    errorMessage,
});

export const flightRequestCreated = (successMessage: any) => ({
    type: FLIGHT_REQUEST_CREATED,
    successMessage,
});

export const clearConfirmOfferFlightRequest = () => ({
    type: CONFIRM_OFFER_FLIGHT_REQUEST_CLEAR,
    payload: {},
});

export const clearFinalRejectionOfFlightRequest = () => ({
    type: AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_CLEAR,
    payload: {},
});

export const clearAirlineRequestAfterRejection = () => ({
    type: AIRLINE_REQUEST_AFTER_REJECTION_CLEAR,
    payload: {},
});
